import { PostSection } from "@/components/blog/PostSection";

export function ImpactoSectorSection() {
  return (
    <PostSection id="impacto-por-sector" title="Impacto por sector e industria">
      <p>
        No todos los sectores se ven afectados de la misma manera. La frecuencia con la que aparecen 
        AI Overviews varía enormemente según la industria y el tipo de consulta.
      </p>

      <h3 id="salud-tecnologia" className="text-xl font-bold text-white mt-8 mb-4">
        Salud y tecnología: los más afectados
      </h3>
      <div className="overflow-x-auto mt-4">
        <table className="w-full text-sm text-left text-gray-300 border border-gray-700 rounded-lg">
          <thead className="text-xs uppercase bg-seo-blue/20 text-seo-bright">
            <tr>
              <th className="px-4 py-3">Sector</th>
              <th className="px-4 py-3">Frecuencia AI Overview</th>
              <th className="px-4 py-3">Impacto en tráfico</th>
              <th className="px-4 py-3">Prioridad</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b border-gray-700">
              <td className="px-4 py-3 font-medium text-white">Salud y Medicina</td>
              <td className="px-4 py-3">Muy alta (45-50%)</td>
              <td className="px-4 py-3">Redistribución significativa</td>
              <td className="px-4 py-3 text-red-400 font-bold">Crítica</td>
            </tr>
            <tr className="border-b border-gray-700">
              <td className="px-4 py-3 font-medium text-white">Tecnología</td>
              <td className="px-4 py-3">Alta (35-40%)</td>
              <td className="px-4 py-3">Redistribución moderada</td>
              <td className="px-4 py-3 text-orange-400 font-bold">Alta</td>
            </tr>
            <tr className="border-b border-gray-700">
              <td className="px-4 py-3 font-medium text-white">Finanzas</td>
              <td className="px-4 py-3">Alta (30-35%)</td>
              <td className="px-4 py-3">Redistribución moderada</td>
              <td className="px-4 py-3 text-orange-400 font-bold">Alta</td>
            </tr>
            <tr className="border-b border-gray-700">
              <td className="px-4 py-3 font-medium text-white">B2B / SaaS</td>
              <td className="px-4 py-3">Media (25-30%)</td>
              <td className="px-4 py-3">Creciente</td>
              <td className="px-4 py-3 text-orange-400 font-bold">Alta</td>
            </tr>
            <tr className="border-b border-gray-700">
              <td className="px-4 py-3 font-medium text-white">eCommerce</td>
              <td className="px-4 py-3">Media (20-25%)</td>
              <td className="px-4 py-3">Mixto</td>
              <td className="px-4 py-3 text-yellow-400 font-bold">Media</td>
            </tr>
            <tr>
              <td className="px-4 py-3 font-medium text-white">Negocios locales</td>
              <td className="px-4 py-3">Baja (10-15%)</td>
              <td className="px-4 py-3">Mínimo</td>
              <td className="px-4 py-3 text-green-400 font-bold">Menor</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h3 id="ecommerce-local" className="text-xl font-bold text-white mt-8 mb-4">
        eCommerce y negocios locales: oportunidad diferencial
      </h3>
      <p>
        Los <strong>negocios locales</strong> siguen beneficiándose del Local Pack de Google, que mantiene 
        su protagonismo frente a los AI Overviews. Para el <strong>eCommerce</strong>, las consultas de producto 
        específicas aún generan clics directos, aunque las comparativas y búsquedas informativas previas 
        a la compra sí se ven afectadas.
      </p>
      <p className="mt-4">
        La clave está en entender que <strong>cada sector necesita una estrategia diferente</strong> de 
        adaptación a los AI Overviews, basada en el tipo de consultas que recibe y la frecuencia con la 
        que aparecen resúmenes de IA en sus búsquedas objetivo.
      </p>
    </PostSection>
  );
}
